/**
 * Full-screen wrapper for capture-flow pages (outside the tab chrome).
 * Back header + mobile-width content column, like a stacked PWA page.
 */
import React from 'react';
import { useNavigation } from '@/hooks/useNavigationContext';
import { Box, Stack, IconButton, Typography } from '@mui/material';

import { ChevronLeftIcon } from './LocalIcons';
import { palette } from './palette';

interface FlowScreenProps {
  children: React.ReactNode;
  /** Where Back goes. Defaults to browser back. */
  backTo?: string;
  /** Hide the back button (e.g. while processing). */
  hideBack?: boolean;
  /** Dark mode for the camera screen. */
  isDark?: boolean;
}

export const FlowScreen = ({
  children,
  backTo,
  hideBack,
  isDark,
}: FlowScreenProps) => {
  const navigate = useNavigation();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: isDark ? palette.ink : palette.cream,
      }}
    >
      <Stack
        sx={{
          maxWidth: 480,
          margin: '0 auto',
          minHeight: '100vh',
          paddingBottom: 4,
        }}
      >
        <Stack
          direction='row'
          sx={{ alignItems: 'center', padding: '12px 8px' }}
        >
          {!hideBack && (
            <IconButton
              aria-label='Back'
              onClick={() => (backTo ? navigate(backTo) : navigate(-1))}
              sx={{ color: isDark ? palette.cream : palette.ink }}
            >
              <ChevronLeftIcon size={22} />
              <Typography sx={{ fontSize: 14, ml: 0.25 }}>Back</Typography>
            </IconButton>
          )}
        </Stack>
        <Box sx={{ flex: 1, padding: '0 20px' }}>{children}</Box>
      </Stack>
    </Box>
  );
};

export default FlowScreen;
